import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

// Module to required plan mapping
const MODULE_PLAN_REQUIREMENT = {
  'dashboard': 'starter',
  'invoices': 'starter',
  'quotes': 'starter',
  'clients': 'starter',
  'products': 'starter',
  'expenses': 'starter',
  'fiscal': 'starter',
  'settings': 'starter',
  'faq': 'starter',
  'reminders': 'starter',
  'support': 'starter',
  'recurring': 'pro',
  'hr-dashboard': 'pro',
  'employees': 'pro',
  'payslips': 'pro',
  'absences': 'pro',
  'accounting': 'pro',
  'shopify': 'pro',
  'team': 'pro',
  'ai-assistant': 'enterprise',
};

export const usePlanAccess = () => {
  const { user, isAuthenticated } = useAuth();
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPlanAccess = useCallback(async () => {
    if (!isAuthenticated) { setLoading(false); return; }
    try {
      const res = await api.get('/auth/plan-access');
      setPlanData(res.data);
    } catch {
      // Fallback: admin gets everything
      if (user?.role === 'admin') {
        setPlanData({ plan: 'enterprise', modules: Object.keys(MODULE_PLAN_REQUIREMENT), trial: null, status: 'active' });
      }
    } finally { setLoading(false); }
  }, [isAuthenticated, user?.role]);

  useEffect(() => { fetchPlanAccess(); }, [fetchPlanAccess]);

  const hasAccess = (module) => {
    if (user?.role === 'admin') return true;
    if (!planData) return true; // Still loading, don't block
    return planData.modules?.includes(module) ?? false;
  };

  const getRequiredPlan = (module) => MODULE_PLAN_REQUIREMENT[module] || 'starter';

  const plan = planData?.plan || (user?.role === 'admin' ? 'enterprise' : 'starter');
  const trial = planData?.trial || null;
  const status = planData?.status || user?.status || 'trial';

  return { plan, trial, status, hasAccess, getRequiredPlan, loading, refresh: fetchPlanAccess };
};

export default usePlanAccess;
